export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size * (532 / 512)}
      viewBox="0 0 512 532"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Hex-tile shield: "A blockchain shield protecting your files" */}

      {/* Folder Tab: 3 hexes */}
      <polygon points="76,19 106,2 136,19 136,53 106,70 76,53" fill="#0d9488" />
      <polygon points="136,19 166,2 196,19 196,53 166,70 136,53" fill="#0d9488" />
      <polygon points="196,19 226,2 256,19 256,53 226,70 196,53" fill="#0d9488" />

      {/* Row 0: 7 hexes */}
      <polygon points="46,70 76,53 106,70 106,104 76,121 46,104" fill="#0d9488" />
      <polygon points="106,70 136,53 166,70 166,104 136,121 106,104" fill="#0d9488" />
      <polygon points="166,70 196,53 226,70 226,104 196,121 166,104" fill="#0d9488" />
      <polygon points="226,70 256,53 286,70 286,104 256,121 226,104" fill="#0d9488" />
      <polygon points="286,70 316,53 346,70 346,104 316,121 286,104" fill="#0d9488" />
      <polygon points="346,70 376,53 406,70 406,104 376,121 346,104" fill="#0d9488" />
      <polygon points="406,70 436,53 466,70 466,104 436,121 406,104" fill="#0d9488" />

      {/* Row 1: 6 hexes */}
      <polygon points="76,121 106,104 136,121 136,155 106,172 76,155" fill="#0d9488" />
      <polygon points="136,121 166,104 196,121 196,155 166,172 136,155" fill="#0d9488" />
      <polygon points="196,121 226,104 256,121 256,155 226,172 196,155" fill="#0d9488" />
      <polygon points="256,121 286,104 316,121 316,155 286,172 256,155" fill="#0d9488" />
      <polygon points="316,121 346,104 376,121 376,155 346,172 316,155" fill="#0d9488" />
      <polygon points="376,121 406,104 436,121 436,155 406,172 376,155" fill="#0d9488" />

      {/* Row 2: 7 hexes */}
      <polygon points="46,172 76,155 106,172 106,206 76,223 46,206" fill="#0d9488" />
      <polygon points="106,172 136,155 166,172 166,206 136,223 106,206" fill="#0d9488" />
      <polygon points="166,172 196,155 226,172 226,206 196,223 166,206" fill="#0d9488" />
      <polygon points="226,172 256,155 286,172 286,206 256,223 226,206" fill="#0d9488" />
      <polygon points="286,172 316,155 346,172 346,206 316,223 286,206" fill="#0d9488" />
      <polygon points="346,172 376,155 406,172 406,206 376,223 346,206" fill="#0d9488" />
      <polygon points="406,172 436,155 466,172 466,206 436,223 406,206" fill="#0d9488" />

      {/* Row 3: 6 hexes */}
      <polygon points="76,223 106,206 136,223 136,257 106,274 76,257" fill="#0d9488" />
      <polygon points="136,223 166,206 196,223 196,257 166,274 136,257" fill="#0d9488" />
      <polygon points="196,223 226,206 256,223 256,257 226,274 196,257" fill="#0d9488" />
      <polygon points="256,223 286,206 316,223 316,257 286,274 256,257" fill="#0d9488" />
      <polygon points="316,223 346,206 376,223 376,257 346,274 316,257" fill="#0d9488" />
      <polygon points="376,223 406,206 436,223 436,257 406,274 376,257" fill="#0d9488" />

      {/* Row 4: 5 hexes */}
      <polygon points="106,274 136,257 166,274 166,308 136,325 106,308" fill="#0d9488" />
      <polygon points="166,274 196,257 226,274 226,308 196,325 166,308" fill="#0d9488" />
      <polygon points="226,274 256,257 286,274 286,308 256,325 226,308" fill="#0d9488" />
      <polygon points="286,274 316,257 346,274 346,308 316,325 286,308" fill="#0d9488" />
      <polygon points="346,274 376,257 406,274 406,308 376,325 346,308" fill="#0d9488" />

      {/* Row 5: 4 hexes */}
      <polygon points="136,325 166,308 196,325 196,359 166,376 136,359" fill="#0d9488" />
      <polygon points="196,325 226,308 256,325 256,359 226,376 196,359" fill="#0d9488" />
      <polygon points="256,325 286,308 316,325 316,359 286,376 256,359" fill="#0d9488" />
      <polygon points="316,325 346,308 376,325 376,359 346,376 316,359" fill="#0d9488" />

      {/* Row 6: 3 hexes */}
      <polygon points="166,376 196,359 226,376 226,410 196,427 166,410" fill="#0d9488" />
      <polygon points="226,376 256,359 286,376 286,410 256,427 226,410" fill="#0d9488" />
      <polygon points="286,376 316,359 346,376 346,410 316,427 286,410" fill="#0d9488" />

      {/* Row 7: 2 hexes */}
      <polygon points="196,427 226,410 256,427 256,461 226,478 196,461" fill="#0d9488" />
      <polygon points="256,427 286,410 316,427 316,461 286,478 256,461" fill="#0d9488" />

      {/* Row 8: 1 hex (point) */}
      <polygon points="226,478 256,461 286,478 286,512 256,529 226,512" fill="#0d9488" />

      {/* Blockchain blocks — filed records */}
      <polygon points="237,130 256,119 275,130 275,152 256,163 237,152" fill="white" />
      <polygon points="250,163 256,159 262,163 262,175 256,179 250,175" fill="white" />
      <polygon points="237,232 256,221 275,232 275,254 256,265 237,254" fill="white" />
      <polygon points="250,265 256,261 262,265 262,277 256,281 250,277" fill="white" />
      <polygon points="237,334 256,323 275,334 275,356 256,367 237,356" fill="white" />
    </svg>
  );
}
